const TextIconSVG = ({ className = "" }) => {
  return (
    // <svg
    //   className={className}
    //   width="25"
    //   height="24"
    //   viewBox="0 0 25 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M14.4297 2H6.42969C5.89925 2 5.39055 2.21071 5.01547 2.58579C4.6404 2.96086 4.42969 3.46957 4.42969 4V20C4.42969 20.5304 4.6404 21.0391 5.01547 21.4142C5.39055 21.7893 5.89925 22 6.42969 22H18.4297C18.9601 22 19.4688 21.7893 19.8439 21.4142C20.219 21.0391 20.4297 20.5304 20.4297 20V8L14.4297 2Z"
    //     stroke="#333333"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M14.4297 2V8H20.4297"
    //     stroke="#333333"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M16.4297 13H8.42969"
    //     stroke="#333333"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M16.4297 17H8.42969"
    //     stroke="#333333"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M10.4297 9H9.42969H8.42969"
    //     stroke="#333333"
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>

    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M6 2H14L20 8V22H6V2Z" fill="#FF6B6B"/>
      <path d="M14 2V8H20" fill="#FF8A8A"/>
      <text x="8" y="16" font-size="6" fill="white" font-family="Arial" font-weight="bold">PDF</text>
    </svg>
  );
};

export default TextIconSVG;
